/* istanbul ignore file */
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { BufferModes } from '@mirage-projects/cw-models';

/**
 * This service enables the communication from and to the buffer tool
 * to execute different tasks.
 */
@Injectable({ providedIn: 'root' })
export class BufferToolCommunicationService {
    private changeModeSubject$ = new Subject<BufferModes>();
    private changeMode$ = this.changeModeSubject$.asObservable();
    private setCrossSectionPositionSubject$ = new Subject<number>();
    private setCrossSectionPosition$ = this.setCrossSectionPositionSubject$.asObservable();

    /**
     * Changes the selected buffer mode to the one supplied
     */
    changeMode(bufferMode: BufferModes): void {
        this.changeModeSubject$.next(bufferMode);
    }

    /**
     * Returns an observable to know when the mode has changed in the buffer tool
     */
    onChangeMode(): Observable<BufferModes> {
        return this.changeMode$;
    }

    /**
     * Sets the cross section position
     */
    setCrossSectionPosition(params: number): void {
        this.setCrossSectionPositionSubject$.next(params);
    }

    /**
     * Returns an observable to know when the cross section position has to be changed
     */
    onSetCrossSectionPosition(): Observable<number> {
        return this.setCrossSectionPosition$;
    }
}
